import { resolveAiRoute } from "./routeResolver.js";

const NAV_THROTTLE_MS = 500;

/**
 * Runs whitelisted AI tool calls (e.g. ui.navigate).
 * @param {{ navigate: (path: string) => void; lastNavigationRef?: { current: { path: string; ts: number } | null } }} deps
 */
export function createToolRunner({ navigate, lastNavigationRef }) {
  return {
    runToolCalls(toolCalls) {
      if (!Array.isArray(toolCalls) || toolCalls.length === 0) return;
      for (const tc of toolCalls) {
        const name = typeof tc?.name === "string" ? tc.name : "";
        const args = tc?.args && typeof tc.args === "object" ? tc.args : {};
        if (!name) continue;
        const isNav = name === "ui.navigate" || name === "navigation.goTo";
        if (isNav) {
          const raw = typeof args.route === "string" ? args.route.trim() : "";
          if (!raw) continue;
          const res = resolveAiRoute(raw);
          if (!res.ok) {
            if (import.meta.env?.DEV) {
              console.warn("[AI tools]", name, "skipped:", res.reason, { raw });
            }
            continue;
          }
          const path = res.path;
          if (lastNavigationRef?.current) {
            const { path: lastPath, ts } = lastNavigationRef.current;
            if (lastPath === path && Date.now() - ts < NAV_THROTTLE_MS) {
              if (import.meta.env?.DEV) {
                console.log("[AI tools]", name, "throttled (same path within 500ms)", { path });
              }
              continue;
            }
          }
          if (import.meta.env?.DEV) {
            console.log("[AI tools]", name, { raw, resolved: path });
          }
          if (lastNavigationRef) lastNavigationRef.current = { path, ts: Date.now() };
          navigate(path);
          continue;
        }
        if (import.meta.env?.DEV) {
          console.warn("[AI tools] unknown tool, ignoring:", name, args);
        }
      }
    },
  };
}
